<template>
  <!-- IL COMPONENTE VISUALIZZA IL MENU' UTENTE SECONDO QUANTO RIPORTATO NELLA CONFIGURAZIONE PASSATA -->
  <!-- E RELATIVAMENTE AI PERMESSI CHE L'UTENTE STESSO POSSIEDE. SONO VISULIZZATI SOLO GLI ELEMENTI   -->
  <!-- DELLA CONFIGURAZIONE EPR LA QUALE L'UTENTE HA I PERMESSI. IL MENU' CONSTA DI DUE POSSIBILI     -->
  <!-- LIVELLI. SI PUO' QUINDI OPTARE PER LINK DIRETTI DI PRIMO LIVELLO OPPURE BADGE DI PRIMO LIVELLO -->
  <!-- CHE APRONO ALTRI LINK DI PRIMO LIVELLO.                                                        -->
  <div>
    <!-- === Rendering del primo livello del menù dove sono presentate le diverse sezioni === -->
    <div v-if="show_main_menu">
      <b-card v-for="( section, index ) in menu_utente" :key="'main-section-' + index" no-body class="mt-3" >
        <b-card-header v-b-toggle="['section'+index]" :style="customer_styles.header_sezioni">
          <h4>{{section.section_title}}</h4>
        </b-card-header>
        <b-collapse :id="'section'+index" :visible="index===0" role="tabpanel">

        <b-card-body>

          <!-- Slot per inserire contenuto nella b-card prima della griglia del menù pricipale di questa sezione -->
          <!-- gli passo il contenuto della sezione nella chiave "section_content" per poterlo eventualmente utilizzare -->
          <!-- da dentro lo slot. -->
          <slot name="section-menu-before" v-bind:section_content="section"></slot>

          <!-- Rendering del menù -->
          <b-row class="text-center mt-3">
            <b-col>
              <!-- Utilizzo la funzione di support ripartisci_in_righe per trasformare i permessi in un'array di array -->
              <!-- dove ogni sottoarray rappresenta una riga con al più N elementi -->
              <b-row v-for="( row_elem, index ) in ripartisci_in_righe(section.section_menu)" :key="'main-menu-' + index" >
                <b-col v-for="( col_elem, index ) in row_elem" :key="'main-menu-' + index" sm>
                  <!-- Se l'elemento NON HA UN SECONDO LIVELLO allora gli passo il nome della route da seguire al click -->
                  <div v-if="col_elem.subroutes === undefined">
                    <!-- Se non ha un titolo allora è un placehoder inserito dalla ripartizione in righe per questo show_bagde=false -->
                    <ServiceBadge  v-if="col_elem.title.length == 0" :show_badge="false"></ServiceBadge>
                    <ServiceBadge  v-else :title="col_elem.title" :image="col_elem.image" :route_name="col_elem.route_name" :direct_link="col_elem.direct_link" :show_badge="true"></ServiceBadge>
                  </div>
                  <!-- Se invece HA UN SECONDO LIVELLO non passo le informazioni sulla route ma mi pongo in ascolto dell'evento -->
                  <!-- emesso dal service badge per capire quale sotto sezione devo aprire -->
                  <div v-else>
                    <!-- Se non ha un titolo allora è un placehoder inserito dalla ripartizione in righe per questo show_bagde=false e non ascolto eventi -->
                    <ServiceBadge v-if="col_elem.title.length == 0" :show_badge="false"></ServiceBadge>
                    <ServiceBadge v-else :title="col_elem.title"
                                  :image="col_elem.image"
                                  :show_badge="true"
                                  :subsection_name="col_elem.subsection_name"
                                  @openSubsection="apri_sottosezione( $event.subsection_name )"></ServiceBadge>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <!-- Slot per inserire contenuto nella b-card dopo della griglia del menù pricipale di questa sezione -->
          <!-- gli passo il contenuto della sezione nella chiave "section_content" per poterlo eventualmente utilizzare -->
          <!-- da dentro lo slot. -->
          <slot name="section-menu-after" v-bind:section_content="section"></slot>

        </b-card-body>
        </b-collapse>
      </b-card>
    </div>

    <!-- === Rendering di tutti i sotto menù, renderizzo solo gli elementi che hanno le subroutes === -->
    <!-- === e per la quale il flag show_subsection è a true === -->
    <div  v-for="( section, index ) in menu_utente" :key="'sub-section-' + index">
      <div v-for="( section_menu, index ) in section.section_menu" :key="'sub-section-menu' + index">
        <b-card v-if="section_menu.subroutes !== undefined && section_menu.show_subsection === true" no-body class="mt-3" >
          <b-card-header :style="customer_styles.header_sezioni">
            <h4>{{section.section_title}} - {{section_menu.title}}</h4>
          </b-card-header>
          <b-card-body>

            <!-- Slot per inserire contenuto nella b-card prima della griglia del menù pricipale di questa sotto sezione -->
            <!-- gli passo il contenuto della sottosezione nella chiave "subsection_content" per poterlo eventualmente utilizzare -->
            <!-- da dentro lo slot. -->
            <slot name="subsection-menu-before" v-bind:subsection_content="section_menu"></slot>

            <!-- Pulsante per tornare al menù principale -->
            <b-row>
              <b-col>
                <b-button @click="apri_menu_principale" variant="primary">
                  <b-icon icon="caret-left-fill"></b-icon><font-awesome-icon icon="home" class="mr-2"/> Torna al menù principale
                </b-button>
              </b-col>
            </b-row>

            <!-- Rendering della sottosezione -->
            <b-row class="text-center mt-3">
              <b-col>
                <!-- Utilizzo la funzione di support ripartisci_in_righe per trasformare i permessi in un'array di array -->
                <!-- dove ogni sottoarray rappresenta una riga con al più N elementi -->
                <b-row v-for="( row_elem, index ) in ripartisci_in_righe(section_menu.subroutes)" :key="'subroute-menu-' + index" >
                  <b-col v-for="( col_elem, index ) in row_elem" :key="'subroute-entry-' + index" sm>
                    <!-- Se non ha un titolo allora è un placehoder inserito dalla ripartizione in righe per questo show_bagde=false -->
                    <ServiceBadge v-if="col_elem.title.length == 0" :show_badge="false"></ServiceBadge>
                    <ServiceBadge v-else :title="col_elem.title" :image="col_elem.image" :route_name="col_elem.route_name" :direct_link="col_elem.direct_link" :show_badge="true"></ServiceBadge>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <!-- Slot per inserire contenuto nella b-card prima della griglia del menù pricipale di questa sotto sezione -->
            <!-- gli passo il contenuto della sottosezione nella chiave "subsection_content" per poterlo eventualmente utilizzare -->
            <!-- da dentro lo slot. -->
            <slot name="subsection-menu-after" v-bind:subsection_content="section_menu"></slot>

          </b-card-body>
        </b-card>
      </div>
   </div>


  </div>
</template>

<script>
// @ is an alias to /src
import ServiceBadge from '@/components/home_components/ServiceBadge.vue'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'HomeMenu',
  data () {
    return {
      // Flag per la visualizzazione del menù principale.
      show_main_menu : true,

      // Menu utente composto dalla page_struct opportunamente
      // filtrata per non visualizzare le parti per la quale l'utente
      // non ha i permessi
      menu_utente : [],

      // Elementi da porre in ciascuna riga dei menù ( massimo 12
      // perchè tale numero è il max supportato da bootstrap )
      row_elements : 4
    }
  },
  methods: {
    /**
     * Cerca nel menù utente una sottosezione tramite il tree-name e
     * la rende visibile ponendo il flag show_subsection a true.
     * Contemporaneamente nasconde il menù principale.
     *
     * - subsection_name : nome della sottosezione da visualizzare
     */
    apri_sottosezione : function ( subsection_name ) {

      this.show_main_menu = false;

      for ( let section of this. menu_utente) {
        for ( let subsection of section.section_menu ) {
          if ( subsection.subsection_name === subsection_name ) {
            subsection.show_subsection = true;
            break;
          }
        }
      }
    },
    /**
     * Chiude tutte le eventuali sottosezioni aperte agendo sul flag
     * show_subsection di ognuna e torna a visualizzare il menù principale.
     */
    apri_menu_principale : function () {
      for ( let section of this. menu_utente) {
        for ( let subsection of section.section_menu ) {
          subsection.show_subsection = false;
        }
      }
      this.show_main_menu = true;
    },
    /**
     * Torna gli elementi presenti nelle varie sezioni prendendo la
     * struttura e modificandola con i soli elementi che questo utente
     * deve visualizzare.
     */
    inizializza_menu_utente : function () {

        // Se la struttura è vuota torniamo subito
        if ( this.menu_struct.length === 0 ) return [];

        let output = [];

        for ( let elem of this.menu_struct ){
            // Andiamo a filtrare le voci di menù e sottomenù di questa sezione in base
            // ai permessi utente.
            let section_elements = this.filtra_permessi_sezione( elem.section_menu );
            // Se dopo il filtraggio la sezione risulta vuota non la includiamo in visualizzazione
            if ( section_elements.length === 0 ) continue;
            // Altrimenti la piazziamo in output con il suo titolo e le voci di menù abilitate
            output.push( { section_title : elem.section_title, section_menu : section_elements } );
        }

        return output;

    },
    /**
     * Data un'array con i servizi nella sezione del menù li filtra tornando
     * solo quanto abiliato per l'utente.
     */
    filtra_permessi_sezione : function ( cfg_object ) {

      // Prendo i permessi dallo store, per semplicità di scrittura li
      // metto in una variaible locale
      let user_perms = this.$store.state.user_perms;

      // Se l'utente non ha permessi posso subito tornare un'array vuota.
      if ( user_perms.length == 0 ) return [];

      // === INIT: Prepariamo tutto il necessario! ===
      let output = [];

      const user_has_salabam_wiaggiare_perm = user_perms.findIndex(perm => perm === 'conv-salabam-wiaggiare') !== -1

      // Separo le chiavi da quelle che iniziano per 'tree-' ( che includono cioè
      // un sottomenù ) da quelle che non iniziando per 'tree-'
      let tree_elements = user_perms.filter( function ( value ) {
        return value.startsWith( "tree-" );
      });

      // Ordino le chiavi tree trovate nei permessi secondo l'ordine della configurazione
      // altrimenti ciclando sotto seguirei l'ordine indicato nei permessi ( quello della
      // tree_elements sopra )
      let ordered_tree_elements = [];
      for ( let cfg_item of cfg_object ){
        if ( Object.prototype.hasOwnProperty.call( cfg_item, 'subsection_name' ) ) {
          if ( tree_elements.includes( cfg_item.subsection_name ) ) {
            ordered_tree_elements.push( cfg_item.subsection_name );
          }
        }
      }

      let not_tree_elements = user_perms.filter( function ( value ) {
        return !value.startsWith( "tree-" );
      });

      // === PARTE 1: Gestione delle sottosezioni ( menù con primo e secondo livello ) ===
      // Per ogni elemento tree nei permessi:
      for ( let trel of ordered_tree_elements ){

        // lo cerca nella configurazione ( nome di sottosezione )
        let cfg_tree = cfg_object.filter( function ( value ) {
          return value.subsection_name === trel;
        });

        // filter torna un'array pertanto se lo trova lo toglie dall'array,
        // se invece non esiste andiamo al prossimo
        cfg_tree = cfg_tree.length > 0 ? cfg_tree[0] : null;
        if ( cfg_tree === null ) continue;

        // se l'elemento esiste lo usiamo per crearne uno nuovo con l'array delle
        // subroutes vuota
        let new_subsection = { title : cfg_tree.title,
                               image : cfg_tree.image,
                               subsection_name : cfg_tree.subsection_name,
                               show_subsection : cfg_tree.show_subsection,
                               subroutes : [],
                               hidden : user_has_salabam_wiaggiare_perm && trel === 'tree-convenzioni' }

        // prendiamo l'array delle subroutes dalla configurazione
        let subroutes_array = cfg_tree.subroutes;

        // cicliamo le subroutes ed inseriamo solo quelle che sono presenti
        // nei permessi utente
        for ( let subel of subroutes_array ) {
          if ( not_tree_elements.includes( subel.route_name ) ) {
            new_subsection.subroutes.push( subel );
          }
        }

        // Se il nuovo oggetto non ha subroutes allora non devo inserirlo e passo
        // al prossimo
        if ( new_subsection.subroutes.length == 0 ) continue;

        // se invece ci sono delle subroutes allora lo inserisco in output
        output.push( new_subsection );

      }

      // === PARTE 2: Gestione dei menù di primo livello senza sottosezioni ===

      // Prendo tutti gli elementi della configurazione che non hanno la chiave
      // subroutes
      let first_level_elems = cfg_object.filter( function ( value ) {
        return !Object.prototype.hasOwnProperty.call( value, 'subroutes' )
      });

      // Di questi vedo quali rientrano nei permessi utente ( chiavi non tree )
      // e li inserisco in output
      for ( let fle of first_level_elems ) {
        if ( not_tree_elements.includes( fle.route_name ) ) {
          output.push( fle );
        }
      }

      // === PARTE 3: ordinamento degli elementi nella sottosezione ===
      // Vado a riordinare gli elementi della sottosezione seguendo l'ordine
      // che è stato dato loro in configurazione. Infatti se lascio l'output
      // così com'è, trattando prima l'algoritmo nella parte 1 tutti gli elementi tree
      // ( con sottosezioni ) e poi gli elementi senza sottosezioni nella parte 2,
      // avrò sempre per primi tutti i menù con sottosezione e a seguire gli altri,
      // non riuscirei quindi a porre un elemento senza sottosezione prima od in
      // mezzo agli elementi con sottosezione.
      let ordered_output = [];
      // Il risultato di filter è sempre un array anche se ho un solo elemento
      // ecco perchè inizializziamo così questa variabile.
      let item_in_output = [];

      // Cicliamo quindi seguendo l'ordine imposto dalla configurazione
      for ( let cfg_item of cfg_object ) {
        if ( Object.prototype.hasOwnProperty.call( cfg_item, 'subsection_name' ) ) {
          // L'elemento è una sottosezione, lo cerchiamo nell'array degli elementi
          // filtrati per permessi utente
          item_in_output = output.filter( function ( value ) {
            return value.subsection_name === cfg_item.subsection_name;
          });
        } else {
          // L'elemento non è una sottosezione, lo cerchiamo nell'array degli elementi
          // filtrati per permessi utente
          item_in_output = output.filter( function ( value ) {
            return value.route_name === cfg_item.route_name;
          });
        }

        // Se l'elemento esiste nell'array di output perchè permissionato per l'utente,
        // lo aggiungiamo.
        if ( item_in_output.length > 0 ) {
            ordered_output.push( item_in_output[0] );
        }
      }
      
      return ordered_output;
    },
    /**
     * Da usare durante il rendering delle righe con le voci di menù,
     * ripartisce l'array degli oggetti con le voci di menù in un'array
     * di array dove ogni sotto array ha al massimo row_elements elementi
     */
    ripartisci_in_righe : function( menu_entries ) {

        let res = new Array();
        let start = 0;
        let stop = this.row_elements;
        menu_entries = menu_entries.filter(m => !m.hidden)

        while ( start <= menu_entries.length ) {
            if ( menu_entries.slice( start, stop ).length > 0 ) {
                res.push( menu_entries.slice( start, stop ) );
            }
            start += this.row_elements;
            stop += this.row_elements;
        }

        // Devo agire con questo if per tornare contenuti nulli, sia in generale che quando
        // il componente, in fase di creazione, ha ancora l'array elements vuota.
        if ( res.length === 0 ) return res;

        // Prendo l'ultima sotto array, se non è lunga quanto il numero di elementi
        // da avere sulla riga, inserisco tanti elementi "place holder" quanti ne
        // mancano
        let last_array_len = res[ res.length - 1].length;
        let elem_to_add = this.row_elements - last_array_len;

        for ( let i=0 ; i < elem_to_add ; i++ ) {
            res[ res.length - 1].push( { title : "", image : "", route_name : "" } );
        }

        return res;
    }
  },
  /**
   * Alla creazione del componente va a caricare i permessi utente per poter visualizzare
   * le voci di menù che questo ha abilitate.
   */
  created : function () {
    axios.get( apiUrl.welfareapi.get_menu_perms )
    .then( (response) => {

      // Siccome gli elementi dei permessi sono chiavi che hanno sempre
      // 1 come valore, possiamo sin da subito ridurre l'oggetto ad
      // un'array con i nomi delle chiavi, andiamo poi a settare i permessi
      // nello store per poi procedere all'inizializzazione del menù.
      // E' importante settare i pemessi nello store perchè siano accessibili
      // oltre che da questo componente, anche dal router in modo tale da
      // evitare di accedere alle route non consentite all'utente.
      let user_perms = [];
      for ( let elem in response.data ) {
        user_perms.push( elem );
      }

      this.$store.commit( 'set_user_perms', user_perms );

      this.menu_utente = this.inizializza_menu_utente();

      if ( this.params && this.params.subsection_name ) {
        this.show_main_menu = false;
        this.apri_sottosezione( this.params.subsection_name );
      }

    })
    .catch( (error) => {
      generalLib.backend_error_message_box( this, error.response.data );
    })
  },
  props: {
    /**
     * Array con la configurazione strutturale del menù che poi viene
     * modificata internamente per adeguarla ai permessi utente tramite
     * la funzione "inizializza_menu_utente"
     */
    menu_struct: {
      type: Array,
      required: true
    },
    /**
     * Oggetto con gli stili di interfaccia per questo particolare menù.
     * Lo passiamo come prop di modo tale che per ogni menù possiamo andare
     * a configurare diverse colorazioni. Infatti la colorazione è presa
     * dalla mappa degli stili sulla base del nome del componente che la usa,
     * quindi possiamo ad esempio passare una serie di impostazioni per la home
     * del dipende ed una per la home del referente aziendale.
     */
    customer_styles : {
      type: Object,
      required: true
    },
    params: {
      type: Object,
      required: false
    }
  },
  components: {
    ServiceBadge
  }
}
</script>

<style scoped></style>
